export enum SectionType {
  transactions = 'transactions',
  orders = 'orders',
  statements = 'statements',
  payments = 'payments',
  tax = 'tax',
  chilled = 'chilled',
}
